import styled from 'styled-components';
import DownBlueArrowSvg from '../../assets/wallet/down-blue.svg';

const DownBlueArrowIcon = styled(DownBlueArrowSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '2.4rem'};
height: ${props => props.height || '2.4rem'};
display: flex;
`;

export default DownBlueArrowIcon;
